export default "assets/images/icons/phone2-3887f7d0.svg";